
import type { PropType } from 'vue'
import type { Sector } from '@/new-services/types/sectors'

import { defineComponent, reactive } from 'vue'

import Loader from '@/common/components/UI/Loader/index.vue'

import DwStaticRecordMarker from '@/modules/DispatcherWorkplaceModule/components/DwStaticRecordMarker/index.vue'

export default defineComponent({
    components: {
        Loader,
        DwStaticRecordMarker,
    },
    props: {
        sectorsLoading: {
            type: Boolean,
            default: false,
        },
        sectors: {
            type: Array as PropType<Array<Sector>>,
            default: () => []
        },
        sidebarOpened: {
            type: Boolean,
            default: true
        }
    },
    setup() {
        const state = reactive({
            is_opened: false,
        })

        const toggle = () => {
            state.is_opened = !state.is_opened
        }

        return {
            state,
            toggle
        }
    }
})
